export default __webpack_public_path__ + "static/kawecki-8664426bebdc687cb0d61508d26b7153.jpg";